import {makeStyles} from "@material-ui/core"

export default makeStyles(theme => ({
    container: {
        [theme.breakpoints.down("sm")]: {
            order: 1,
        },
    },
    dialog: {
        width: 400,
    },
    actions: {
        justifyContent: "flex-end",
    },
}))
